import 'rc-slider/assets/index.css';

import { HStack, Text, VStack } from '@chakra-ui/react';
import Slider from 'rc-slider';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { IndicatorDriver } from 'models/response/driver.interface';
import { InputAdjutment } from 'models/requestBody/getModelOutputs.interface';
import { GetInputAdjustments } from 'redux/driverAdjustmentSlice';
import { getBaseScenario } from 'redux/ScenarioSlice';
import { getPlanPageThemeColors } from 'redux/ThemeSlice';
import { usePlanPageRevampVariant } from 'pages/PlanPageDetailsOPZ/PlanPageUIRevamp/usePlanPageUiRevamp';

interface Properties {
  driver: IndicatorDriver;
  onAdjustInput: (parameter: InputAdjutment) => void;
  isResetClicked: boolean;
  setIsResetClicked: (value: boolean) => void;
  variant?: 'legacy' | 'revamp';
}

const SliderComponent = ({
  driver,
  onAdjustInput,
  isResetClicked,
  setIsResetClicked,
  variant = 'legacy',
}: Properties) => {
  const isRevamp = usePlanPageRevampVariant(variant);
  const themeColors = useSelector(getPlanPageThemeColors);
  const Value = useSelector(GetInputAdjustments);
  const sliderValue = Value !== null && Value[driver.id] ? Value[driver.id] : 0;
  const [currentSliderValue, setCurrentSliderValue] = useState(sliderValue);
  const baseScenario = useSelector(getBaseScenario);

  useEffect(() => {
    setCurrentSliderValue(sliderValue);
  }, [sliderValue]);

  useEffect(() => {
    if (isResetClicked) {
      setCurrentSliderValue(0);
      setIsResetClicked(false);
    }
  }, [isResetClicked, setIsResetClicked]);

  useEffect(() => {
    setCurrentSliderValue(0);
  }, [baseScenario?.id]);

  const setSliderValue = (value: number | number[]) => {
    const nextValue = Array.isArray(value) ? value[0] : value;
    onAdjustInput({ [driver.id]: nextValue });
  };

  const trackColor = isRevamp ? themeColors.primary : 'white';
  const railColor = isRevamp ? themeColors.border : '#CDCDCD66';

  return (
    <VStack w='full' spacing={isRevamp ? 2 : '1'} width={isRevamp ? '100%' : '90%'} align='stretch'>
      <HStack w='full' justify='space-between' align='center'>
        <Text
          fontSize={isRevamp ? '14px' : undefined}
          fontWeight={isRevamp ? '500' : undefined}
          color={isRevamp ? themeColors.textDark : undefined}
          size={isRevamp ? undefined : 'modalContent'}
          noOfLines={1}
          flex='1'
          pr={2}
        >
          {driver.name}
        </Text>
        <Text
          fontSize={isRevamp ? '12px' : undefined}
          fontWeight={isRevamp ? '600' : undefined}
          size={isRevamp ? undefined : 'modalContent'}
          py={isRevamp ? 1 : '2'}
          px={isRevamp ? 2 : '1'}
          minW={isRevamp ? '44px' : '11'}
          textAlign='center'
          borderRadius={isRevamp ? '8px' : 'xs'}
          bg={isRevamp ? themeColors.activeBg : undefined}
          bgColor={isRevamp ? undefined : 'violet.50'}
          color={isRevamp ? themeColors.primary : undefined}
        >
          {currentSliderValue}%
        </Text>
      </HStack>
      <Slider
        min={-100}
        max={100}
        startPoint={0}
        value={currentSliderValue}
        onChange={setCurrentSliderValue}
        onAfterChange={setSliderValue}
        trackStyle={{ backgroundColor: trackColor, height: isRevamp ? 6 : 8 }}
        railStyle={{ backgroundColor: railColor, height: isRevamp ? 6 : 8 }}
        handleStyle={{
          borderColor: isRevamp ? themeColors.primary : '#CDCDCD66',
          backgroundColor: isRevamp ? themeColors.surface : undefined,
          height: isRevamp ? 14 : 16,
          width: isRevamp ? 14 : 16,
          marginTop: isRevamp ? -4 : undefined,
        }}
      />
    </VStack>
  );
};

export default SliderComponent;
